// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ef8474cb","83":"7f25ad2a","261":"acfdb2d2","301":"3e93a56d","412":"0df4c42f"}[chunkId] + ".chunk.js";
};